// Security mode only (called from SecurityGlobalHeader). Legacy views that stay linked from
// the navbar and footer are never edited, so their page titles cannot take the .sec-h1
// class. This tags each legacy page's first h1 with .sec-legacy-title instead, and
// security-theme.css gives that the security pages' title style. Light titles (white text
// on a photo banner) also get .sec-legacy-title--light so they keep their colour.
// A MutationObserver re-tags after every route change and after async content renders.
import { onMounted, onUnmounted } from 'vue';

const TAG = 'sec-legacy-title';

const isLight = (el) => {
  const [r, g, b] = (getComputedStyle(el).color.match(/\d+/g) || []).map(Number);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 160;
};

const tagTitle = () => {
  const h1 = document.querySelector('#app h1');
  if (!h1 || h1.classList.contains('sec-h1') || h1.classList.contains(TAG)) return;
  if (isLight(h1)) h1.classList.add(`${TAG}--light`);
  h1.classList.add(TAG);
};

export function useLegacyPageTitle() {
  let observer;
  onMounted(() => {
    const app = document.getElementById('app');
    if (!app) return;
    tagTitle();
    observer = new MutationObserver(tagTitle);
    observer.observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
  onUnmounted(() => observer && observer.disconnect());
}
